import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Translations } from '@app/core/services/i18n/translations.service';

@Component({
  selector: 'app-settings-dialog',
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.scss']
})
export class SettingsDialogComponent {
  constructor(public dialogRef: MatDialogRef<SettingsDialogComponent>, public translations: Translations) {}

  close(): void {
    this.dialogRef.close();
  }
}
